/**
 * @param {String} x
 * @return {String}
 */
export const trim = (x) => String.prototype.trim.call(x);
